import React, { useState, useRef, useEffect } from "react";
import { CONSTANT_CURRENCY } from "../../../constant/common";
import Spinner from "../../common/Spinner";
import { fetchData } from "../../../api/api";
import { formatDateForView } from "../../../utils/formateDate";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const AdminBillingHistory = () => {
  const didFetch = useRef(false);

  const [isLoading, setIsLoading] = useState(false);

  const [ordersList, setOrdersList] = useState([]);

  const getOrders = async () => {
    setIsLoading(true);
    try {
      const data = await fetchData("/get-orders", {});
      setOrdersList(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!didFetch.current) {
      getOrders();
      didFetch.current = true;
    }
  }, []);

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(ordersList.length / itemsPerPage);

  const paginatedData =
    ordersList?.length > 0
      ? ordersList.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : [];

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleDownload = (fileUrl) => {
    fetch(fileUrl, { method: "HEAD" }) 
      .then((response) => {
        if (response.ok) {
         
          return fetch(fileUrl); 
        } else {
          toast.error("File not found!"); 
          throw new Error("File not found");
        }
      })
      .then((response) => response.blob()) 
      .then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const alink = document.createElement("a");
  
        alink.href = fileURL;
        alink.download = "NewInvoice.pdf"; 
        alink.click(); 
      })
      .catch((error) => {
        console.error("Error downloading the file:", error);
      });
  };

  if (isLoading) {
    return <Spinner adminLayout={true} />;
  }
  return (
    <>
      <ul className="flex gap-2 text-base font-medium text-dark mb-5">
        <li>
          <a href="#" className="text-blue">
            Billing
          </a>
        </li>
        <li>/</li>
        <li>
          <span>Billing History</span>
        </li>
      </ul>
      <div className="rounded-[20px] overflow-hidden overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-blue">
              <th className="p-2 sm:p-4 text-white text-sm sm:text-base font-semibold text-start">
                Invoice
              </th>
              <th className="p-2 sm:p-4 text-white text-sm sm:text-base font-semibold text-start">
                Billing Date
              </th>
              <th className="p-2 sm:p-4 text-white text-sm sm:text-base font-semibold text-start min-w-56">
                Plan
              </th>
              <th className="p-2 sm:p-4 text-white text-sm sm:text-base font-semibold text-start">
                Card
              </th>
              <th className="p-2 sm:p-4 text-white text-sm sm:text-base font-semibold text-start">
                Amount
              </th>
              <th className="p-2 sm:p-4 text-white text-sm sm:text-base font-semibold text-start">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="bg-[#f4f4f4]">
            {paginatedData?.length > 0 ? (
              paginatedData?.map((item, index) => (
                <tr key={index}>
                  <td className="p-2 sm:p-4 text-dark text-sm sm:text-base font-medium align-top border-b border-[#DFDFDF] text-nowrap">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleDownload(process.env.REACT_APP_API_URL + item?.pdf_url);
                      }}
                      className="text-blue"
                    >
                      {item?.orders_number}
                    </Link>
                  </td>
                  <td className="p-2 sm:p-4 text-dark text-sm sm:text-base font-medium align-top border-b border-[#DFDFDF] text-nowrap">
                    {formatDateForView(item?.created_date)}
                  </td>
                  <td className="p-2 sm:p-4 text-dark text-sm sm:text-base font-medium align-top border-b border-[#DFDFDF]">
                    <p className="mb-3">{item?.pricing_plan?.name} Plan</p>
                    <span className="font-normal block">
                      Duration - {item?.pricing_plan?.duration}
                    </span>
                  </td>
                  <td className="p-2 sm:p-4 text-dark text-sm sm:text-base font-medium align-top border-b border-[#DFDFDF] text-nowrap">
                    {item?.card ? (
                      <>
                        <p>{item?.card?.card_holder_name}</p>
                        <p>
                          {item?.card?.card_brand?.charAt(0).toUpperCase() +
                            item?.card?.card_brand?.slice(1) +
                            "-" +
                            item?.card?.last_4}
                        </p>
                        <p>
                          Expiry -{" "}
                          {item?.card?.exp_month + "/" + item?.card?.exp_year}
                        </p>
                      </>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="p-2 sm:p-4 text-dark text-sm sm:text-base font-medium align-top border-b border-[#DFDFDF] text-nowrap">
                    {CONSTANT_CURRENCY + parseInt(item?.amount)}
                  </td>
                  <td className="p-2 sm:p-4 align-top border-b border-[#DFDFDF]">
                    <span
                      className={`text-white text-sm sm:text-base font-medium text-center px-3 py-0.5 rounded-full text-nowrap capitalize ${
                        item?.payment_status === "succeeded"
                          ? "bg-green"
                          : "bg-red-600"
                      }`}
                    >
                      {item?.payment_status === "succeeded" ? "Paid" : "Not Paid"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className="p-2 sm:p-4 text-dark text-sm sm:text-base font-medium align-top border-b border-[#DFDFDF] text-nowrap text-center"
                >
                  No invoice Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {paginatedData?.length > 0 && (
        <div className="px-3 py-3 border-solid border-[#dfdfdf]">
          <ul className="flex items-center -space-x-px h-10 text-base justify-end">
            {/* Previous Button */}
            <li>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] 
          ${
            currentPage === 1
              ? "text-gray-400 bg-gray-200 cursor-not-allowed"
              : "text-blue bg-gray-200 hover:bg-gray-100"
          }`}
              >
                <svg
                  className="w-3 h-3 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 1 1 5l4 4"
                  ></path>
                </svg>
              </button>
            </li>

            {/* Dynamic Pagination Logic */}
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter((page) => {
                return (
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                );
              })
              .reduce((acc, page, index, arr) => {
                if (index > 0 && page !== arr[index - 1] + 1) {
                  acc.push("...");
                }
                acc.push(page);
                return acc;
              }, [])
              .map((page, index) => (
                <li key={index}>
                  {page === "..." ? (
                    <span
                      className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}
                    >
                      ...
                    </span>
                  ) : (
                    <button
                      onClick={() => handlePageChange(page)}
                      className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] 
                ${
                  currentPage === page
                    ? "bg-white text-blue"
                    : "bg-gray-200 text-blue hover:bg-gray-100"
                }`}
                    >
                      {page}
                    </button>
                  )}
                </li>
              ))}

            {/* Next Button */}
            <li>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] 
          ${
            currentPage === totalPages
              ? "text-gray-400 bg-gray-200 cursor-not-allowed"
              : "text-blue bg-gray-200 hover:bg-gray-100"
          }`}
              >
                <svg
                  className="w-3 h-3 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 9 4-4-4-4"
                  ></path>
                </svg>
              </button>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default AdminBillingHistory;
